import { apiDelete, apiGet, apiPatch, apiPost } from "./client";
import type { Org, OrgMember, OrgMemberRole } from "@sales-ops-amplify/shared";

export interface OrgWorkspaceResponse {
  org: Org | null;
  role: OrgMemberRole | null;
  members: Array<{
    userId: string;
    email?: string;
    role: OrgMemberRole;
    status: string;
    createdAt: string;
  }>;
}

export async function getOrgWorkspace(): Promise<OrgWorkspaceResponse> {
  return apiGet<OrgWorkspaceResponse>("/api/org");
}

export async function createOrg(name: string): Promise<Org> {
  const res = await apiPost<{ org: Org }>("/api/org", { name });
  return res.org;
}

export async function updateOrg(patch: {
  name?: string;
  primaryCrm?: "hubspot" | "salesforce";
}): Promise<Org> {
  const res = await apiPatch<{ org: Org }>("/api/org", patch);
  return res.org;
}

export async function listOrgMembers(): Promise<OrgMember[]> {
  const res = await apiGet<{ members: OrgMember[] }>("/api/org/members");
  return res.members ?? [];
}

export async function inviteOrgMember(
  email: string,
  role: OrgMemberRole = "member",
): Promise<OrgMember> {
  const res = await apiPost<{ member: OrgMember }>("/api/org/members", {
    email,
    role,
  });
  return res.member;
}

export async function updateOrgMemberRole(
  userId: string,
  role: OrgMemberRole,
): Promise<OrgMember> {
  const res = await apiPatch<{ member: OrgMember }>(
    `/api/org/members/${encodeURIComponent(userId)}`,
    { role },
  );
  return res.member;
}

export async function removeOrgMember(userId: string): Promise<void> {
  await apiDelete(`/api/org/members/${encodeURIComponent(userId)}`);
}

export async function backfillOrgData(): Promise<{
  updated: {
    opportunities: number;
    contacts: number;
    companies: number;
    signals: number;
  };
}> {
  return apiPost("/api/org/backfill");
}
